import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import React from 'react';
import classes from './SelectConnection.module.scss';

interface CredentialFilterToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const CredentialFilterToggle = ({ checked, onChange }: CredentialFilterToggleProps) => (
  <ToggleButtonGroup
    exclusive
    value={checked ? 'with-credentials' : 'all'}
    onChange={(_, value: string | null) => {
      if (value !== null) onChange(value === 'with-credentials');
    }}
    aria-label="Show connectors"
    size="small"
    className={classes.credentialFilter}
  >
    <ToggleButton value="all">All connectors</ToggleButton>
    <ToggleButton value="with-credentials" title="Show only connectors with saved credentials">
      With credentials
    </ToggleButton>
  </ToggleButtonGroup>
);
